import { Role } from '@/types';

export const hasRights = (actionFrom: Role, applyTo: Role = Role.MEMBER) => {
  const hierarchy = [null, Role.MEMBER, Role.ADMIN, Role.OWNER];
  return hierarchy.indexOf(actionFrom) > hierarchy.indexOf(applyTo);
};
